import React, { useState, useEffect } from "react";
import moment from "moment";
import Calendar from "react-calendar";

import KeyboardArrowDownIcon from "../assets/KeyboardArrowIcon";
import NumberInput from "./input/NumberInput";
import TextInput from "./input/TextInput";
import RadioInput from "./input/RadioInput";
import CheckBoxInput from "./input/CheckBoxInput";
import SelectInput from "./input/SelectInput";
import Summary from "./booking/Summary";
import UserDetails from "./booking/UserDetails";

import "../index.css";

function BookingModule({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  isSubmitting,
  page,
  bookingConfirmation,
  details,
  availableSlots,
  preferredTimeOptions,
  titleOptions,
  durationOptions,
  countryPhoneCodes,
  services,
  paymentChannelOptions,
  priceCalculation,
  isPrivacyPolicyAgreementChecked,
  setIsPrivacyPolicyAgreementChecked,
  storeCurrency,
}) {
  const [accordionOpen, setAccordionOpen] = useState([]);
  const [durationFieldName, setDurationFieldName] = useState("Duration");
  const [availableDateList, setAvailableDateList] = useState([]);
  availableSlots?.map((slot) => {
    const availableTime =
      slot &&
      slot.availableTime &&
      slot.availableTime
        .filter((item) => {
          const dateNow = new Date();
          const dateSlot = new Date(
            `${slot && slot.date} ${item && item.time}`
          );
          // const dateQuota = details && details.quota
          // return dateSlot > dateNow && dateQuota > 0
          return dateSlot > dateNow;
        })
        .sort((a, b) => a?.id - b?.id);
    slot.availableTime = availableTime;
    return slot;
  });

  const selectedSlot = availableSlots?.find(
    (slot) => slot.date === moment(values.date).format("YYYY-MM-DD")
  );
  const selectedTime = selectedSlot?.availableTime
    ?.find((item) => item.id.toString() === values.time)
    ?.time?.split(":");

  const handleToggleFAQ = (index) => {
    if (accordionOpen.includes(index)) {
      setAccordionOpen((prev) => prev.filter((i) => i !== index));
    } else {
      setAccordionOpen((prev) => [...prev, index]);
    }
  };

  const handleChangeGuest = (type) => {
    if (type === "min") {
      if (values.num_guests > 1) {
        handleChange({
          target: {
            value: values.num_guests - 1,
            name: "num_guests",
          },
        });
      }
    } else if (values.num_guests < 10) {
      handleChange({
        target: {
          value: values.num_guests + 1,
          name: "num_guests",
        },
      });
    }
  };

  const availableDates = (selectedOption, durationSlotOptions) => {
    let availableDateList = [];
    const selectedSlotOption = durationSlotOptions.find(
      (slot) => slot.id == selectedOption
    );
    if (
      selectedSlotOption &&
      selectedSlotOption.timeslots &&
      selectedSlotOption.timeslots.length > 0 &&
      selectedSlotOption.timeslots[0]
    ) {
      if (
        selectedSlotOption.timeslots[0].morning &&
        selectedSlotOption.timeslots[0].morning.length > 0
      ) {
        selectedSlotOption.timeslots[0].morning.forEach((element) => {
          if (element.is_available) {
            availableDateList.push(moment(element.date).format("YYYY-MM-DD"));
          }
        });
      }
      if (
        selectedSlotOption.timeslots[0].afternoon &&
        selectedSlotOption.timeslots[0].afternoon.length > 0
      ) {
        selectedSlotOption.timeslots[0].afternoon.forEach((element) => {
          if (element.is_available) {
            availableDateList.push(moment(element.date).format("YYYY-MM-DD"));
          }
        });
      }
      if (
        selectedSlotOption.timeslots[0].evening &&
        selectedSlotOption.timeslots[0].evening.length > 0
      ) {
        selectedSlotOption.timeslots[0].evening.forEach((element) => {
          if (element.is_available) {
            availableDateList.push(moment(element.date).format("YYYY-MM-DD"));
          }
        });
      }
    }
    availableDateList = [...new Set(availableDateList)];
    return availableDateList;
  };

  useEffect(() => {
    if (durationOptions && durationOptions.length > 0) {
      const optionTitle =
        durationOptions && durationOptions[0] && durationOptions[0].title;
      const fieldName = optionTitle.split(" - ");
      if (fieldName && fieldName.length > 0 && fieldName[1]) {
        setDurationFieldName(fieldName[0]);
      } else {
        setDurationFieldName("Service package");
      }
    }
  }, [durationOptions]);

  useEffect(() => {
    const dateList = availableDates(values.duration, durationOptions);
    setAvailableDateList(dateList);
  }, [durationOptions, values.duration]);

  return (
    <div className="space-y-4 sm:space-y-6">
      {page === 4 ? (
        <>
          <p className="mb-2 text-base text-center sm:text-2xl sm:mb-4">
            Thank you for your booking
          </p>
          <div className="flex flex-col items-center p-4 space-y-2 border border-black rounded-md bg-app-light-grey">
            <p className="text-sm font-bold uppercase sm:text-base text-app-grey">
              Booking number confirmation
            </p>
            <p className="text-base sm:text-2xl">
              {bookingConfirmation.number}
            </p>
          </div>
          <p className="px-2 text-sm text-center sm:px-8 sm:text-base">
            {bookingConfirmation.description}
          </p>
        </>
      ) : page === 3 ? (
        <>
          <div className="space-y-4">
            <div className="flex items-center justify-between border-b border-black">
              <p className="mb-2 text-base sm:text-2xl sm:mb-4">
                Booking summary
              </p>
              <button
                className="flex items-center gap-2"
                onClick={() => handleToggleFAQ(1)}
              >
                <p className="text-xs uppercase sm:text-sm">View</p>
                <div
                  className={`${
                    accordionOpen.includes(1) ? "rotate-180" : "rotate-0"
                  } transition-all`}
                >
                  <KeyboardArrowDownIcon />
                </div>
              </button>
            </div>
            {accordionOpen.includes(1) && (
              <Summary
                details={details}
                date={new Date(values.date).setHours(
                  selectedTime[0],
                  selectedTime[1]
                )}
                num_guests={values.num_guests}
              />
            )}
          </div>

          <div className="space-y-4">
            <div className="flex items-center justify-between border-b border-black">
              <p className="mb-2 text-base sm:text-2xl sm:mb-4">Your details</p>
              <button
                className="flex items-center gap-2"
                onClick={() => handleToggleFAQ(2)}
              >
                <p className="text-xs uppercase sm:text-sm">View</p>
                <div
                  className={`${
                    accordionOpen.includes(2) ? "rotate-180" : "rotate-0"
                  } transition-all`}
                >
                  <KeyboardArrowDownIcon />
                </div>
              </button>
            </div>
            {values?.guests?.map((guest, i) => {
              return (
                <div className="space-y-2">
                  {accordionOpen.includes(2) && (
                    <UserDetails
                      index={i}
                      titleOptions={titleOptions}
                      values={guest}
                      errors={errors.guests?.[i]}
                      touched={touched.guests?.[i]}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      countryPhoneCodes={countryPhoneCodes}
                    />
                  )}
                </div>
              );
            })}
          </div>

          <p className="mb-2 text-base sm:text-2xl sm:mb-4">
            Proceed to payment
          </p>
          <div className="px-4 py-4 space-y-4 border border-black rounded-xl">
            <p className="text-sm font-bold sm:text-lg">Payment method</p>
            <div className="space-y-4">
              <RadioInput
                name="payment_method"
                styled
                options={paymentChannelOptions}
                onChange={handleChange}
                onBlur={handleBlur}
                error={
                  errors?.payment_method &&
                  touched?.payment_method &&
                  errors?.payment_method
                }
                value={values.payment_method}
              />

              {/* <p className='text-sm font-bold sm:text-lg'>Payment details</p> */}
              {/* <div className='grid grid-cols-1 gap-4 sm:grid-cols-2'>
                  <NumberInput
                      name="card_number"
                      label="Card number"
                      placeholder="0000 0000 0000 0000"
                      required
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={(errors?.card_number && touched?.card_number) && errors.card_number}
                      value={values.card_number}
                  />
                  <NumberInput
                      name="cvc"
                      label="CVC number"
                      placeholder="123"
                      required
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={(errors?.cvc && touched?.cvc) && errors.cvc}
                      value={values.cvc}
                  />
                  <TextInput
                      name="card_holder_name"
                      label="Card holder name"
                      placeholder="John Doe"
                      required
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={(errors?.card_holder_name && touched?.card_holder_name) && errors.card_holder_name}
                      value={values.card_holder_name}
                  />
                  <TextInput
                      name="expiry_date"
                      label="Expiry date"
                      placeholder="12/25"
                      required
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={(errors?.expiry_date && touched?.expiry_date) && errors.expiry_date}
                      value={values.expiry_date}
                  />
                  <TextInput
                      name="billing_address"
                      label="Billing address"
                      placeholder="Melrose Avenue 198 Block 228 Los Angeles, United States"
                      required
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={(errors?.billing_address && touched?.billing_address) && errors.billing_address}
                      value={values.billing_address}
                  />
                  <NumberInput
                      name="postal_code"
                      label="Postal code"
                      placeholder="10000"
                      required
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={(errors?.postal_code && touched?.postal_code) && errors.postal_code}
                      value={values.postal_code}
                  />
                  <TextInput
                      name="city"
                      label="Town/city"
                      placeholder="Los Angeles"
                      required
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={(errors?.city && touched?.city) && errors.city}
                      value={values.city}
                  />
              </div> */}
            </div>
          </div>

          <div className="px-4 py-4 space-y-4 border border-black rounded-xl bg-app-light-grey">
            <div className="flex justify-between px-4 text-sm">
              <div>
                <p>Service Price</p>
              </div>
              {!details.sale_amount ? (
                <p>
                  {(values.num_guests * details.amount).toLocaleString(
                    "id-ID",
                    {
                      style: "currency",
                      currency:
                        storeCurrency && storeCurrency?.code
                          ? storeCurrency?.code
                          : "IDR",
                    }
                  )}
                </p>
              ) : (
                <div className="flex gap-2">
                  <p className="line-through">
                    {(values.num_guests * details.amount).toLocaleString(
                      "id-ID",
                      {
                        style: "currency",
                        currency:
                          storeCurrency && storeCurrency?.code
                            ? storeCurrency?.code
                            : "IDR",
                      }
                    )}
                  </p>
                  <p className="text-red-500">
                    {(values.num_guests * details?.sale_amount).toLocaleString(
                      "id-ID",
                      {
                        style: "currency",
                        currency:
                          storeCurrency && storeCurrency?.code
                            ? storeCurrency?.code
                            : "IDR",
                      }
                    )}
                  </p>
                </div>
              )}
            </div>
            <div className="flex justify-between px-4 text-sm">
              <div>
                <p>PPN 11%</p>
              </div>
              <p>
                {priceCalculation &&
                  priceCalculation.pTaxPrice &&
                  priceCalculation.pTaxPrice.toLocaleString("id-ID", {
                    style: "currency",
                    currency:
                      storeCurrency && storeCurrency?.code
                        ? storeCurrency?.code
                        : "IDR",
                  })}
              </p>
            </div>
            <div className="flex justify-between px-4 text-sm">
              <div>
                <p>Transaction Fee</p>
              </div>
              <p>
                {priceCalculation &&
                  priceCalculation.mTaxPrice &&
                  priceCalculation.mTaxPrice.toLocaleString("id-ID", {
                    style: "currency",
                    currency:
                      storeCurrency && storeCurrency?.code
                        ? storeCurrency?.code
                        : "IDR",
                  })}
              </p>
            </div>
            <div className="flex justify-between px-4 text-sm">
              <div>
                <p>Transaction Tax</p>
              </div>
              <p>
                {priceCalculation &&
                  priceCalculation.mFeePrice &&
                  priceCalculation.mFeePrice.toLocaleString("id-ID", {
                    style: "currency",
                    currency:
                      storeCurrency && storeCurrency?.code
                        ? storeCurrency?.code
                        : "IDR",
                  })}
              </p>
            </div>
            <div className="flex justify-between px-4 text-sm font-bold sm:text-lg">
              <div>
                <p>Total Amount</p>
              </div>
              <p>
                {priceCalculation &&
                  priceCalculation.finalPrice &&
                  priceCalculation.finalPrice.toLocaleString("id-ID", {
                    style: "currency",
                    currency:
                      storeCurrency && storeCurrency?.code
                        ? storeCurrency?.code
                        : "IDR",
                  })}
              </p>
            </div>
          </div>

          <button
            type="submit"
            className="w-full p-2 text-sm text-white bg-black rounded-xl sm:text-base"
            onClick={handleSubmit}
          >
            Make payment
          </button>
        </>
      ) : page === 2 ? (
        <>
          <p className="mb-2 text-base sm:text-2xl sm:mb-4">Your cart</p>
          <Summary
            details={details}
            date={new Date(values.date).setHours(
              selectedTime[0],
              selectedTime[1]
            )}
            num_guests={values.num_guests}
          />

          <p className="mb-2 text-base sm:text-2xl sm:mb-4">Your details</p>
          <div className="px-4 py-4 space-y-4 border border-black rounded-xl">
            <TextInput
              name="email"
              label="Email address"
              placeholder="Enter your email address here"
              required
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors?.email && touched?.email && errors.email}
              value={values.email}
              infoText="Booking confirmation will be sent to this email address."
            />
          </div>
          {values?.guests?.map((guest, i) => {
            return (
              <div className="space-y-2">
                <UserDetails
                  index={i}
                  titleOptions={titleOptions}
                  editable
                  values={guest}
                  errors={errors.guests?.[i]}
                  touched={touched.guests?.[i]}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  countryPhoneCodes={countryPhoneCodes}
                />
              </div>
            );
          })}
          <CheckBoxInput
            name="agree"
            label={
              <>
                I agree to{" "}
                <a href="/" className="text-app-blue">
                  terms and conditions
                </a>{" "}
                and{" "}
                <a href="/" className="text-app-blue">
                  privacy policy
                </a>
              </>
            }
            onChange={() =>
              setIsPrivacyPolicyAgreementChecked(
                !isPrivacyPolicyAgreementChecked
              )
            }
            checked={isPrivacyPolicyAgreementChecked === true}
          />
          <button
            className="w-full p-2 text-sm text-white bg-black rounded-xl sm:text-base disabled:opacity-30"
            disabled={isSubmitting || isPrivacyPolicyAgreementChecked === false}
            onClick={handleSubmit}
          >
            Complete booking
          </button>
        </>
      ) : (
        <>
          <p className="mb-2 text-base sm:text-2xl sm:mb-4">Add details</p>
          {services?.length > 1 ? (
            <SelectInput
              name="service"
              className=""
              label={details.label}
              options={services}
              onChange={handleChange}
              error={errors?.service && touched?.service && errors?.service}
              value={values?.service}
            />
          ) : (
            <div className="px-4 py-4 space-y-2 border border-black rounded-xl bg-app-light-grey">
              <p className="text-xs font-bold uppercase sm:text-sm text-app-grey">
                {details.label}
              </p>
              <p className="text-sm sm:text-base">{details?.title}</p>
            </div>
          )}
          <div className="flex flex-col gap-2 pb-3 border-b border-b-black">
            <p className="text-sm font-bold sm:text-lg">{durationFieldName}</p>
            <div className="grid items-center grid-cols-2 gap-4 sm:grid-cols-3 sm:gap-6">
              <SelectInput
                name="duration"
                className="w-full col-span-2"
                options={durationOptions}
                onChange={handleChange}
                // error={(errors?.duration && touched?.duration) && errors?.duration}
                value={values?.duration}
              />
              <div className='flex flex-row gap-4'>
                <div className='flex flex-col text-xs whitespace-nowrap sm:text-sm'>
                  <p className='font-bold'>Price: </p>
                  {!details.sale_amount ? (
                    <p className="text-base">
                      {details.amount.toLocaleString("id-ID", {
                        style: "currency",
                        currency:
                          storeCurrency && storeCurrency?.code
                            ? storeCurrency?.code
                            : "IDR",
                      })}
                    </p>
                  ) : (
                    <>
                      <p
                        className={`text-base ${
                          values?.duration && "line-through"
                        }`}
                      >
                        {details.amount.toLocaleString("id-ID", {
                          style: "currency",
                          currency:
                            storeCurrency && storeCurrency?.code
                              ? storeCurrency?.code
                              : "IDR",
                        })}
                      </p>
                      <p
                        className="text-base text-red-500"
                        hidden={!values?.duration}
                      >
                        {details?.sale_amount.toLocaleString("id-ID", {
                          style: "currency",
                          currency:
                            storeCurrency && storeCurrency?.code
                              ? storeCurrency?.code
                              : "IDR",
                        })}
                      </p>
                    </>
                  )}
                </div>
              </div>
            </div>
            {errors?.duration && touched?.duration && (
              <p className="text-xs text-app-brown">
                {durationFieldName} {errors?.duration}
              </p>
            )}
          </div>
          <div className="pb-3 space-y-2 border-b border-b-black">
            <div className="flex items-center justify-between ">
              <p className="text-sm font-bold sm:text-lg">Add guest</p>
              <div className="flex items-center gap-4">
                <button
                  className="flex items-center justify-center w-5 h-5 text-sm border border-black rounded-full sm:text-base sm:w-6 sm:h-6"
                  onClick={() => handleChangeGuest("min")}
                >
                  -
                </button>
                <div className="text-sm sm:text-base">{values.num_guests}</div>
                <button
                  className="flex items-center justify-center w-5 h-5 text-sm border border-black rounded-full sm:text-base sm:w-6 sm:h-6"
                  onClick={() => handleChangeGuest("plus")}
                >
                  +
                </button>
              </div>
            </div>
            {errors?.num_guests && touched?.num_guests && (
              <p className="text-xs sm:text-sm text-app-brown">
                {errors?.num_guests}
              </p>
            )}
          </div>

          <div className="space-y-4">
            <p className="text-sm font-bold sm:text-lg">Pick available dates</p>
            <div>
              <Calendar
                className="app-calendar"
                value={values.date}
                onChange={(date) =>
                  handleChange({ target: { name: "date", value: date } })
                }
                minDate={new Date()}
                tileDisabled={({ activeStartDate, date, view }) =>
                  !availableDateList.filter(
                    (availableDate) =>
                      moment(date).format("YYYY-MM-DD") == availableDate
                  )[0]
                }
              />
            </div>
            {details.schedule_option &&
              details.schedule_option !== "" &&
              details.schedule_option === "weekdays-only" && (
                <p className="text-xs sm:text-sm text-app-brown">
                  * This service is available on selected dates on the weekdays.
                </p>
              )}
            {details.schedule_option &&
              details.schedule_option !== "" &&
              details.schedule_option === "weekend-only" && (
                <p className="text-xs sm:text-sm text-app-brown">
                  * This service is available on selected dates on the weekend.
                </p>
              )}
            {details &&
              details.schedule_window &&
              details.schedule_window !== "" && (
                <p className="text-xs sm:text-sm text-app-brown">{`** If feasible, customers should be able to arrive approximately ${details.schedule_window.replace(
                  "-",
                  " "
                )} earlier than the booking time.`}</p>
              )}
            {errors?.date && touched?.date && (
              <p className="text-xs sm:text-sm text-app-brown">
                {errors?.date}
              </p>
            )}
          </div>

          <div className="grid grid-cols-3 gap-10">
            <SelectInput
              name="preferred_time"
              className="hidden sm:flex"
              label="Preferred Time"
              options={preferredTimeOptions}
              onChange={handleChange}
              error={
                errors?.preferred_time &&
                touched?.preferred_time &&
                errors?.preferred_time
              }
              value={values?.preferred_time}
            />
            <div className="col-span-3 space-y-4 sm:col-span-2">
              <p className="text-sm font-bold sm:text-lg">Available times</p>
              <SelectInput
                name="preferred_time"
                className="flex sm:hidden"
                label="Preferred Time"
                options={preferredTimeOptions}
                onChange={handleChange}
                error={
                  errors?.preferred_time &&
                  touched?.preferred_time &&
                  errors?.preferred_time
                }
                value={values?.preferred_time}
              />
              <div className="grid grid-cols-3 gap-4 w-fit">
                {selectedSlot?.availableTime?.length > 0 ? (
                  selectedSlot?.availableTime?.map((time, i) => {
                    const quota = Number(time.quota);
                    return (
                      <div className="relative group">
                        <input
                          id={time.time}
                          name="time"
                          type="radio"
                          className="hidden peer"
                          value={time.id}
                          onChange={handleChange}
                          checked={time.id?.toString() === values.time}
                          disabled={!quota || quota < values.num_guests}
                        />
                        <label
                          className={`text-xs sm:text-sm text-center inline-block border border-black rounded-xl px-4 py-1 select-none peer-checked:bg-black peer-checked:text-white cursor-pointer ${
                            !quota || quota < values.num_guests
                              ? "bg-gray-200 text-gray-400 "
                              : ""
                          }`}
                          htmlFor={time.time}
                        >
                          {time.time}
                        </label>
                        {/* Tooltip */}
                        {quota ? (
                          <div className="absolute px-3 py-1 text-xs text-white transition -translate-x-1/2 bg-gray-800 rounded-lg opacity-0 pointer-events-none left-1/2 -top-6 group-hover:opacity-100 whitespace-nowrap">
                            {`Slot available: ${quota}`}
                            <div className="absolute w-2 h-2 -mt-1 rotate-45 -translate-x-1/2 bg-gray-800 left-1/2 top-full"></div>
                          </div>
                        ) : null}
                      </div>
                    );
                  })
                ) : (
                  <p className="col-span-3 text-xs sm:text-base text-app-brown">
                    Sorry, the date you selected has no slot available at this
                    preferred time. Please select another preferred time.
                  </p>
                )}
              </div>
              {errors?.time && touched?.time && (
                <p className="text-xs sm:text-sm text-app-brown">
                  {errors?.time}
                </p>
              )}
            </div>
          </div>
          <button
            type="submit"
            className="w-full p-2 text-sm text-white bg-black rounded-xl sm:text-base focus:ring focus:ring-slate-300"
            disabled={isSubmitting}
            onClick={handleSubmit}
          >
            Continue
          </button>
        </>
      )}
    </div>
  );
}

export default BookingModule;
